import React from 'react'
import { Link } from 'gatsby'
import * as styles from './styles.module.scss'

const FeaturedPost = ({ slug, title, publishDate, imageSrc }) => (
  <Link
    to={slug}
    className={`${styles.FeaturedPost} featured-post`}
    data-testid="featured-post"
  >
    <div className={styles.ColLeft}>
      <div className={styles.Title}>
        <h1>{title}</h1>
      </div>
      <div className={styles.CTA}>
        <div className={styles.Button}>Read More</div>
        <small>{publishDate}</small>
      </div>
    </div>
    <div className={styles.ColRight}>
      <img src={`${imageSrc}?w=500&q=50`} alt="" />
    </div>
  </Link>
)

export default FeaturedPost
